import { THEME_SETTINGS } from "@theme-settings";

export const supportEmail = THEME_SETTINGS.supportEmail;

const onboardingRoutes = [
	"register-activation",
	"login",
	"register",
	"registration",
];

const loginFlowRoutes = [
	"register-activation",
	"login",
	"register",
	"registration",
	"force-password-change",
	"betting-activity",
	"match-user",
	"confirm-user-data",
	"accept-new-terms",
	"account-activation",
	"accept-gdpr",
	"user-matching",
];

const loginFlowRouteExceptions = ["login-time"];

export const isOnboardingPage = (currentRoute: string) =>
	onboardingRoutes.some((route) => currentRoute.includes(route)) &&
	!location.search.includes("isErrorPage=true");

export const isLoginFlow = (currentRoute: string) =>
	!loginFlowRouteExceptions.some((exceptionRoute) =>
		currentRoute.includes(exceptionRoute)
	) &&
	loginFlowRoutes.some((route) => currentRoute.includes(route)) &&
	!location.search.includes("isErrorPage=true");

export const isRegistrationDomain = () => {
	return window.location.host.includes("registration.");
};
